module.exports = __webpack_public_path__ + "static/img/74.b9e84a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/74.png
// module id = 0J5r
// module chunks = 1